import { getActiveTenantProfile } from './tenantBranding';

/** How the current session was established (for support / testing). */
export type StoredAuthMethod = 'saml' | 'oidc' | 'password';

export function getAuthMethodStorageKey(): string {
  return `${getActiveTenantProfile().tenantId}-auth-method`;
}

/** @deprecated use getAuthMethodStorageKey() */
export const AUTH_METHOD_STORAGE_KEY = 'provysn-auth-method';

export function setStoredAuthMethod(method: StoredAuthMethod): void {
  localStorage.setItem(getAuthMethodStorageKey(), method);
}

export function getStoredAuthMethod(): StoredAuthMethod | null {
  const v = localStorage.getItem(getAuthMethodStorageKey());
  if (v === 'saml' || v === 'oidc' || v === 'password') return v;
  return null;
}

export function clearStoredAuthMethod(): void {
  localStorage.removeItem(getAuthMethodStorageKey());
}

/** Client deployments default to SAML; set REACT_APP_PRIMARY_SSO=oidc only for Okta OIDC demos. */
export type PrimarySsoMode = 'saml' | 'oidc';

export function getPrimarySsoMode(): PrimarySsoMode {
  const v = process.env.REACT_APP_PRIMARY_SSO?.trim().toLowerCase();
  if (v === 'oidc') return 'oidc';
  return 'saml';
}

export function isOidcCallbackEnabled(): boolean {
  return getPrimarySsoMode() === 'oidc';
}

export function authMethodLabel(method: StoredAuthMethod): string {
  switch (method) {
    case 'saml':
      return 'SAML';
    case 'oidc':
      return 'OIDC';
    case 'password':
      return 'Password';
    default:
      return method;
  }
}
